import {
  FETCH_LAST_DATA_FFD_PVT_INIT,
  FETCH_LAST_DATA_FFD_PVT_SUCCESS,
  FETCH_LAST_DATA_FFD_PVT_FAILURE,
  FETCH_LAST_DATA_FFD_PVT_NO_LOADING_INIT,
  FETCH_LAST_DATA_FFD_PVT_NO_LOADING_SUCCESS,
  FETCH_LAST_DATA_FFD_PVT_NO_LOADING_FAILURE,
  FETCH_LAST_DATA_FFD_PVT_COUNT_INIT,
  FETCH_LAST_DATA_FFD_PVT_COUNT_SUCCESS,
  FETCH_LAST_DATA_FFD_PVT_COUNT_FAILURE,
  RESET_LAST_DATA_FFD_PVT,
  SET_FILTER_LAST_DATA_FFD_PVT,
  SET_ACTIVE_STATE_LAST_DATA_FFD_PVT
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterLastDataFfdPvt(obj) {
  return {
    type: SET_FILTER_LAST_DATA_FFD_PVT,
    payload: obj
  };
}

export function setActiveStateLastDataFfdPvt(obj) {
  return {
    type: SET_ACTIVE_STATE_LAST_DATA_FFD_PVT,
    payload: obj
  };
}

export function resetLastDataFfdPvt() {
  return {
    type: RESET_LAST_DATA_FFD_PVT
  };
}

/* Data  */
function fetchApiSuccess(data) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_INIT
  };
}

export function fetchLastDataFfdPvtApi(obj) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Data  count */
function fetchCountApiSuccess(data) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_COUNT_SUCCESS,
    payload: data
  };
}

function fetchCountApiFailure(error) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_COUNT_FAILURE,
    payload: error
  };
}

function fetchCountApiInit() {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_COUNT_INIT
  };
}

export function fetchLastDataFfdPvtCountApi(obj) {
  return async dispatch => {
    dispatch(fetchCountApiInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchCountApiSuccess(data));
    } catch (error) {
      dispatch(fetchCountApiFailure(error));
    }
  };
}

/*  No loading */

function fetchNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_NO_LOADING_SUCCESS,
    payload: data,
    concat
  };
}

function fetchNoLoadingFailure(error) {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_LAST_DATA_FFD_PVT_NO_LOADING_INIT
  };
}

export function fetchLastDataFfdPvtNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchNoLoadingFailure(error));
    }
  };
}

export function downloadSummaryReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadSummaryReport(filter);
    } catch (error) {}
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/last_data_ffd_pvt/index.js